<template>
  <div class="activity_form_second_sel" >
    <span class="size_small">
      <el-checkbox-group v-model="themeStylesSecond">
        <el-checkbox class="children_item" v-for="itemChild in selectItem.themeLevels" :key="itemChild.themeLevelCode" @change="handleSelectItem" :label="itemChild.themeLevelName" />
      </el-checkbox-group>
    </span>
    <span class="level_input_box" v-if="themeStylesSecondOrder.length>1">
      <span class="level_input" v-for="(item,index) of themeStylesSecondOrder" :key="item.themeLevelCode">
        <span>
          <span v-if="index!=0">
            <!-- <el-form :model="inputData" :rules="rules">
              <el-form-item> -->
                <el-input v-model="inputData[index]" @keydown.native="channelInputLimit" @blur="handleBlur" @select="handleSelect" type="number" :min="1"></el-input>
              <!-- </el-form-item>
            </el-form> -->
          </span>
          <span v-if="index===0"><el-input v-model="inputData[index]" :disabled="true"></el-input></span>{{item.themeLevelName}}
          <span v-if="(index+1)!=themeStylesSecondOrder.length">&nbsp;=</span>
        </span>
      </span>
      <span v-show="isError" class="warning">额度分配比例为小数，请修改额度分配</span>
      <span v-show="inputError" class="warning">请输入额度分配！</span>
    </span>
  </div>
</template>

<script>
export default {
  props:{
    selectItem:{ type:Object, default:()=>{} },
    saveThemeStylesSecond:{ type: Array, default: () => [] },
  },
  data(){
    return {
      themeStylesSecond:[],
      themeStylesSecondOrder:[],
      inputData:[1],
      defaultNum:1,
      rules:{
        inputData:[
          { required: true, message: "请选择是或否", trigger: "blur" }
        ]
      },
      isError:false,
      inputError:false
    }
  },
  watch:{
    'themeStylesSecond'(val,oval){
      // 删除级别
      // if(val.length<oval.length){
      //   // console.log(222);
      //   // for(let i=0;i<this.selectItem.themeStylesSecond.length;i++){
      //   //   let isDelete = true
      //   //   for(let name of val){
      //   //     if(name === this.selectItem.themeStylesSecond[i].themeLevelName){
      //   //       isDelete = false
      //   //     }
      //   //   }
      //   //   if(isDelete){
      //   //     this.selectItem.themeStylesSecond.splice(i,1)
      //   //     delete this.inputData[i]
      //   //   }
      //   // }
      //   // this.$emit("handleThemeStylesSecond",this.selectItem.themeStylesSecond)
      //   this.inputData = [1]
      //   let data = this.selectItem
      //   data.themeStylesSecond = []
      //   this.$emit("handleThemeStylesSecond",data)
      // }else if(val.length>oval.length){
      //   // 新加级别
      //   this.inputData = [1]
      //   let data = this.selectItem
      //   data.themeStylesSecond = []
      //   this.$emit("handleThemeStylesSecond",data)
      // }
    },
    'inputData'(){
      if(this.themeStylesSecondOrder.length===1){
        this.handleSend()
      }
      // else if(this.themeStylesSecondOrder.length>1){
      //   if(this.themeStylesSecondOrder.length==this.inputData.length){
      //       for(let i =0;i<this.themeStylesSecondOrder.length;i++){
      //         let item = this.themeStylesSecondOrder[i]
      //         this.themeStylesSecondOrder[i].nextLevelCode = this.themeStylesSecondOrder[i+1]&&this.themeStylesSecondOrder[i+1].themeLevelCode
      //         this.themeStylesSecondOrder[i].nextLevelRate = Number(this.inputData[i+1])&&this.inputData[i+1]/Number(this.inputData[i]||1)
      //       }
      //       console.log(this.themeStylesSecondOrder);
      //       this.handleSend(true)
      //   }else {
      //     this.$emit("handleThemeStylesSecond",this.selectItem)
      //   }
      // }
    }
  },
  created(){
    this.inputData[0] = 1
    //console.log(this.saveThemeStylesSecond);
    for(let i=0;i<this.saveThemeStylesSecond.length;i++){
      let item = this.saveThemeStylesSecond[i]
      if(this.saveThemeStylesSecond.length>1){
        if(i==0){
          this.inputData[0]=1
          item.isLast = false
        }else if(i<(this.saveThemeStylesSecond.length-1)){
          let data = 0
          this.inputData[i]=this.saveThemeStylesSecond[i-1].nextLevelRate*this.inputData[i-1] || ''
          item.isLast = false
        }else if(i===(this.saveThemeStylesSecond.length-1)){
          this.inputData[i]=this.saveThemeStylesSecond[i-1].nextLevelRate*this.inputData[i-1] || ''
          item.isLast = true
        }
      }
      this.themeStylesSecond.push(item.themeLevelName)
      this.themeStylesSecondOrder.push(item)
    }
    this.handleSend(true)
  },
  methods:{
    channelInputLimit (e) {
            let key = e.key
            // 不允许输入'e'和'.'
            if (key === 'e' || key === '.' || key === '-' || key === '+') {
                e.returnValue = false
                return false
            }
            return true
        },
    handleBlur(event){
      if(this.inputData.length>2){
        let length = this.inputData.length
        let result = this.inputData[length-1]/this.inputData[length-2]
        if(String(result).indexOf(".")>-1){
          this.isError = true
          this.inputError = false
          this.inputData.pop()
          // this.$emit("handleThemeStylesSecond",this.selectItem)
          return
        }
      }
      this.isError = false

      if(this.themeStylesSecondOrder.length==this.inputData.length){
        for(let i = 0;i<this.themeStylesSecondOrder.length;i++){
          let item = this.themeStylesSecondOrder[i]
          this.themeStylesSecondOrder[i].nextLevelCode = this.themeStylesSecondOrder[i+1]&&this.themeStylesSecondOrder[i+1].themeLevelCode
          this.themeStylesSecondOrder[i].nextLevelRate = Number(this.inputData[i+1])&&this.inputData[i+1]/Number(this.inputData[i]||1)
          // if(i===(this.themeStylesSecondOrder.length-1)){
          //   this.isLast = true
          // }
          if(i==(this.themeStylesSecondOrder.length-1)){
            //console.log('last');
            this.themeStylesSecondOrder[i].isLast = true
          }else {
            this.themeStylesSecondOrder[i].isLast = false
          }
        }
        //console.log(this.themeStylesSecondOrder);
        this.handleSend(true)
        this.inputError = false
      }else {
        // this.$emit("handleThemeStylesSecond",this.selectItem)
      }
    },
    // handleSelect(a){
    //   console.log(a);
    // },
    getThemeStylesSecondOrder(){
      this.themeStylesSecondOrder = []
      for(let i = 0;i<this.selectItem.themeLevels.length;i++){
        let item = this.selectItem.themeLevels[i]
        for(let selected of this.themeStylesSecond){
          if(item.themeLevelName===selected){
            this.themeStylesSecondOrder.push(item)
          }
        }
      }
      let themeStylesSecondInfo = {
        ...this.selectItem,
        itemName:this.selectItem.themeStyleName,
        themeStylesSecond:this.themeStylesSecondOrder,
      }
      //console.log(themeStylesSecondInfo);
      this.$emit("handleThemeStylesSecond",themeStylesSecondInfo)
      // if(this.themeStylesSecondOrder.length===1){
      //   let themeStylesSecondInfo = {
      //     ...this.selectItem,
      //     itemName:this.selectItem.themeStyleName,
      //     themeStylesSecond:this.themeStylesSecondOrder,
      //   }
      //   this.$emit("handleThemeStylesSecond",themeStylesSecondInfo)
      // }else {
      //   this.$emit("handleThemeStylesSecond",this.selectItem)
      // }
    },
    handleSend(nextLevelRate){
      let themeStylesSecondInfo = {
        ...this.selectItem,
        itemName:this.selectItem.themeStyleName,
        themeStylesSecond:this.themeStylesSecondOrder,
        nextLevelRate:nextLevelRate || false
      }
      //console.log(themeStylesSecondInfo);
      this.$emit("handleThemeStylesSecond",themeStylesSecondInfo)
    },
    handleSelectItem(){
      this.$emit("handleChangeStyle",this.selectItem.themeStyleCode)
      this.getThemeStylesSecondOrder()
    },
    handleSelect(itemChild){
      this.getThemeStylesSecondOrder()
    },
    handleInputError(themeStyleCode){
      //console.log(themeStyleCode);
      //console.log(this.selectItem.themeStyleCode);
      if(this.selectItem.themeStyleCode===themeStyleCode){
        this.inputError = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .activity_form_second_sel{
    display: flex;
    margin-left: 40px;
    .children_item{
      margin-right: 15px;
    }
  }
  .el-input{
    margin:0 4px 0 5px;
    width: 60px;
  }
.size_small{
    font-size: 14px;
    transform: scale(0.83333);
}
::v-deep  .el-input__inner{
    height: 30px;
    line-height: 30px;
    padding: 0 8px !important;
    text-align: center;
    border-radius: 7px;
  }
  .level_input_box{
    font-size: 13px;
    margin-left: 20px;
  }
.warning{
  display: inline-block;
  margin-left: 10px;
  color: red;
}
</style>